import { CSSProperties } from 'react';

import cx from 'classnames';

import CardTitle from './CardTitle';

import s from './Card.module.scss';

interface IProps {
  bg?: 'white';
  size?: 'sm';
  hover?: boolean;
  className?: string;
  secondaryColor?: string;
  style?: CSSProperties;
}

const Card: React.FC<IProps> = ({
  bg,
  size,
  className = '',
  style,
  secondaryColor,
  children,
}) => (
  <div
    style={style}
    className={cx('', s.card, className, {
      [s.bgWhite]: bg === 'white',
      [s.small]: size === 'sm',
      root: secondaryColor,
      [s.pointer]: secondaryColor,
    })}
  >
    {children}
  </div>
);

export { CardTitle };
export default Card;
